import { print } from 'graphql'
import { Cart } from 'shopify-types'

import { storefrontClient } from '..'
import { RemoveCartLinesDocument, type RemoveCartLinesMutation } from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { mapGQLCartToCart } from './graphql'

export const removeCartLine =
  (options: GlobalRequestOptions) =>
  async (cartId: string, lineIds: string[]): Promise<Cart> => {
    const response = await storefrontClient.request<RemoveCartLinesMutation>(
      print(RemoveCartLinesDocument),
      {
        variables: {
          cartId,
          lineIds,
          language: options.language,
        },
      },
    )

    const payload = response.data?.cartLinesRemove

    if (!payload?.cart) {
      throw new Error('Failed to remove line item')
    }

    return mapGQLCartToCart(payload.cart)
  }
